module.exports = __webpack_public_path__ + "img/consultation_part7.1daf397a.png";